import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import ModalComponent from 'components/ModalComponent';

import './AuditViewer.scss';
import registeredComponent from '../../utils/registeredComponent';

const AuditViewer = ({ id, associated_id, field, resource }) => {
  const [audits, setAudits] = useState([]);

  const datetimeFormat = `${global.I18n.date.formats.default_moment} @ h:mm A`;
  const formatDatetime = (date) => moment(date).format(datetimeFormat);

  async function fetchAudits() {
    let base_path;
    let searchParams = new URLSearchParams();
    if (id) {
      base_path = `/api/audits/${resource}/${id}`;
      if (field) {
        searchParams.set("field", field);
      }
    } else {
      base_path = `/api/audits/${resource}`;
      if (associated_id) {
        searchParams.set("associated_id", associated_id);
      }
    }

    let path = `${base_path}?${searchParams.toString()}`;

    const response = await fetch(path);
    response
      .json()
      .then((json) => setAudits(json.audits));
  }

  useEffect(() => {
    fetchAudits();
  }, []);

  const displayValue = (value) => {
    switch (value) {
      case null:
        return "''";
      case true:
        return 'true';
      case false:
        return 'false';
      default:
        if (Array.isArray(value)) {
          return `[${value.join(', ')}]`;
        } else if (typeof value === 'object') {
          return `{${Object.keys(value).map((key) => (`${key}: ${displayValue(value[key])}`)).join(', ')}}`;
        }
        return value;
    }
  };

  return (
    <ModalComponent title='Recent Edit History' className='audit-viewer'>
      <table className='table'>
        <thead>
          <tr>
            <th>User</th>
            <th>Date</th>
            <th>Changes</th>
          </tr>
        </thead>
        <tbody>
          {audits.map(({ action, audited_changes, created_at, id, user, associated_display_name }, index) => (
            <tr key={index}>
              <td>{user && user.name}</td>
              <td>{formatDatetime(created_at)}</td>
              <td>
                {associated_display_name ?
                  <span>
                    <b>{associated_display_name.prefix}</b> {associated_display_name.name}
                  </span>
                  : ''}
                {
                  action === 'update' && Object.keys(audited_changes).map((key) => (
                    <div key={`${id}.${key}`}>
                      <strong>
                        { key }
                        :
                      </strong>
                      &nbsp;
                      {displayValue(audited_changes[key][0])}
                      &nbsp;→&nbsp;
                      {displayValue(audited_changes[key][1])}
                    </div>
                  ))
                }
                {
                  action === 'create' && Object.keys(audited_changes).map((key) => (
                    <div key={`${id}.${key}`}>
                      <strong>
                        { key }
                        :
                      </strong>
                      &nbsp;
                      [blank]
                      &nbsp;→&nbsp;
                      {displayValue(audited_changes[key])}
                    </div>
                  ))
                }
                {
                  action === 'destroy' && Object.keys(audited_changes).map((key) => (
                    <div key={`${id}.${key}`}>
                      <strong>
                        { key }
                        :
                      </strong>
                      &nbsp;
                      {displayValue(audited_changes[key])}
                      &nbsp;→&nbsp;
                      [blank]
                    </div>
                  ))
                }
              </td>
            </tr>
          )) }
        </tbody>
      </table>

    </ModalComponent>
  );
};

AuditViewer.propTypes = {
  field: PropTypes.string,
  id: PropTypes.string,
  resource: PropTypes.string
};

AuditViewer.defaultProps = {
  field: '',
  id: '',
  resource: ''
};

export default registeredComponent('AuditViewer')(AuditViewer);
